import React from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import FormLabel from '@material-ui/core/FormLabel';
import Paper from '@material-ui/core/Paper';

class FileEditor extends React.Component {
	constructor(props) {
		super(props);
		this.handleUpload = this.handleUpload.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
	}
	handleUpload(event) {
		let reader = new FileReader();
		reader.onload = (loadEvent) => {
			this.props.handleEdit(loadEvent.target.result, true);
		};
		reader.readAsText(event.target.files[0]);
	}
	handleEdit(event) {
		this.props.handleEdit(event.target.value, false);
	}
	render() {
		return (
			<Box my={1}>
				<Paper>
					<Box p={1}>
						<div className="uploadContainer">
							<FormLabel component="legend">{this.props.name}</FormLabel>
							<div className="uploadButton">
								<label>
									<Button variant="outlined" component="span" size="small">Upload...</Button>
									<input className="hidden" type="file" accept={this.props.accept} onChange={this.handleUpload}/>
								</label>
							</div>
						</div>
						<Box p={1}>
							<TextField color="secondary" fullWidth variant="outlined" type="text" multiline={true} rowsMax={33} value={this.props.value} onChange={this.handleEdit}/>
						</Box>
					</Box>
				</Paper>
			</Box>
		);
	}
}

export default FileEditor;